/**
 * Recursively replaces all <fts_match>...</fts_match> tags in string values
 * with <span class="fts_match">...</span> for highlight rendering.
 */
export function replaceFtsMatch(obj) {
  if (typeof obj === "string") {
    return obj.replace(
      /<fts_match>(.*?)<\/fts_match>/g,
      '<span class="fts_match">$1</span>'
    );
  }

  if (Array.isArray(obj)) {
    return obj.map((item) => replaceFtsMatch(item));
  }

  if (obj !== null && typeof obj === "object") {
    return Object.fromEntries(
      Object.entries(obj).map(([key, value]) => [key, replaceFtsMatch(value)])
    );
  }

  return obj;
}
